import { DocumentChartBarIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';

import { DocumentsSections } from '@/components/documents/DocumentsSections';
import { Tooltip } from '@/components/Tooltip';
import { Button } from '@/components/ui/button';
import { GenerateReportWizard } from '@/sections/export/GenerateReportWizard';
import { useAuth } from '@/state/auth';

export const ReportsTab: React.FC = () => {
  const { isPraetorianUser } = useAuth();
  const [wizardOpen, setWizardOpen] = useState(false);

  return (
    <div className="flex h-full flex-col gap-4 overflow-hidden">
      <DocumentsSections
        query="reports"
        includeReports
        enableUpload={false}
        enableSearch={true}
        enableFavorites={true}
        isPraetorianUser={isPraetorianUser}
        showInternalSection={false}
        heading="Reports"
        headerAction={
          isPraetorianUser ? (
            <Button size="sm" onClick={() => setWizardOpen(true)}>
              <DocumentChartBarIcon className="size-4" />
              Generate Report
            </Button>
          ) : (
            <Tooltip title="Managed by Praetorian">
              {/* span wrapper enables hover/focus events on disabled button for tooltip */}
              <span tabIndex={0}>
                <Button size="sm" disabled>
                  <DocumentChartBarIcon className="size-4" />
                  Generate Report
                </Button>
              </span>
            </Tooltip>
          )
        }
        emptyState={{
          title: 'No Reports Yet',
          description: isPraetorianUser
            ? 'Generate your first report to get started'
            : 'Reports generated for you will appear here',
          actionLabel: 'Generate Report',
          onAction: isPraetorianUser ? () => setWizardOpen(true) : undefined,
        }}
      />

      <GenerateReportWizard open={wizardOpen} onOpenChange={setWizardOpen} />
    </div>
  );
};
